var map = {
	"./_placeholder.svg": "VjLL",
	"./access-time.svg": "tnO0",
	"./add-to-list.svg": "DaXg",
	"./add.svg": "9+V+",
	"./arrow-left.svg": "EwiG",
	"./arrow-right.svg": "87TX",
	"./avatar.svg": "1of4",
	"./balloon.svg": "FOEw",
	"./bbfc-logo--black.svg": "cDjD",
	"./bbfc-logo--large-black.svg": "6kR5",
	"./bbfc-logo--strapline.svg": "bP5B",
	"./bbfc-logo--white.svg": "Go3a",
	"./bbfc-logo.svg": "WMY5",
	"./cbbfc-logo--strapline.svg": "uYSG",
	"./cbbfc-logo--white.svg": "qcHU",
	"./chevron-down--teal.svg": "G7Z3",
	"./chevron-down.svg": "knym",
	"./chevron-right.svg": "oScl",
	"./chevron-up--teal.svg": "raV/",
	"./chevron-up.svg": "uail",
	"./chevron.svg": "XLSZ",
	"./clock.svg": "70TV",
	"./close.svg": "v5TL",
	"./download.svg": "rk/Z",
	"./facebook-round.svg": "Wlou",
	"./facebook-square.svg": "wEEE",
	"./facebook.svg": "WTGj",
	"./family--green.svg": "W5eK",
	"./family.svg": "+nVk",
	"./fish--green.svg": "FCsF",
	"./fish--orange.svg": "GouR",
	"./green-triangle.svg": "nRX3",
	"./group1.svg": "w8DM",
	"./hamburger.svg": "AJyK",
	"./heart-solid.svg": "hoCi",
	"./heart.svg": "eqBA",
	"./info.svg": "btqN",
	"./instagram.svg": "yAB0",
	"./list.svg": "PcaU",
	"./location.svg": "dV2V",
	"./menu.svg": "9H6L",
	"./minus.svg": "VE/U",
	"./play.svg": "duqV",
	"./plus.svg": "K+x+",
	"./rating-12.svg": "pRwi",
	"./rating-12a.svg": "Lie+",
	"./rating-15.svg": "loiU",
	"./rating-18.svg": "PN1p",
	"./rating-a.svg": "3ODh",
	"./rating-aa.svg": "aluz",
	"./rating-h.svg": "FFjx",
	"./rating-na.svg": "0/Fo",
	"./rating-pg.svg": "SEGd",
	"./rating-r18.svg": "+CYu",
	"./rating-u.svg": "jeqM",
	"./rating-uc.svg": "xNYV",
	"./rating-x.svg": "RJPs",
	"./reddit.svg": "an4d",
	"./remove.svg": "R93a",
	"./search.svg": "+zOZ",
	"./share.svg": "3X5L",
	"./squiggle.svg": "Uvbb",
	"./triangle.svg": "HnwQ",
	"./triangles.svg": "zLfV",
	"./trophy-2.svg": "EDFy",
	"./trophy.svg": "IPc2",
	"./twitter.svg": "OPph",
	"./upload.svg": "PEbK",
	"./visibility-off.svg": "Nl2G",
	"./visibility.svg": "OZ/M",
	"./wavy-line.svg": "1fBq"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OMOf";